/* Display FALLBACK metadata for Texas State Reports. The select-items API now serves
 * fullName/dueDate/frequency/dataSources per report (StaticDataProvider.GetCBMReportTypes)
 * and the institution identity (CAMSLicenses + Colleges.CollegeCode2); these values are
 * only used when the API omits a field. */

export const CBM_REPORT_META = {
    CBM001: { fullName: 'Student Enrollment Report', due: 'October 31, 2026', frequency: 'Semester', sources: ['Enrollment', 'Registration', 'Demographics'] },
    CBM002: { fullName: 'Success Initiative Report', due: 'November 15, 2026', frequency: 'Semester', sources: ['Enrollment', 'Developmental Education', 'TSI Assessment'] },
    CBM008: { fullName: 'Faculty Report', due: 'November 30, 2026', frequency: 'Semester', sources: ['Faculty', 'Course Sections', 'HR'] },
    CBM009: { fullName: 'Graduation Report', due: 'December 1, 2026', frequency: 'Annual', sources: ['Conferral', 'Awards', 'Degree Audit'] },
    CBM00A: { fullName: 'Continuing Education Students', due: 'December 15, 2026', frequency: 'Semester', sources: ['CE Enrollment', 'Demographics'] },
    CBM00C: { fullName: 'Continuing Education Classes', due: 'December 15, 2026', frequency: 'Semester', sources: ['CE Course Sections', 'Faculty'] },
    CBM00S: { fullName: 'Student Schedule', due: 'October 31, 2026', frequency: 'Semester', sources: ['Registration', 'Course Sections'] },
    CBM0C1: { fullName: 'Student Census', due: 'October 31, 2026', frequency: 'Semester', sources: ['Enrollment', 'Demographics', 'Residency'] },
    CBM0CS: { fullName: 'Census Student Schedule', due: 'October 31, 2026', frequency: 'Semester', sources: ['Registration', 'Course Sections', 'Census Snapshot'] },
    CBM0E1: { fullName: 'End of Semester Students', due: 'February 1, 2027', frequency: 'Semester', sources: ['Enrollment', 'Grades', 'Demographics'] },
    TFADS: { fullName: 'Texas Financial Aid Database', due: '', frequency: 'Annual', sources: ['Financial Aid Awards', 'Disbursements'] },
    TEOG: { fullName: 'TEOG / TX Grant', due: 'September 30, 2026', frequency: 'Annual', sources: ['Financial Aid Awards', 'Disbursements'] }
};

/* Reports with an implemented Texas State Reports extract workflow (Step 1 shows only these). */
export const TEXAS_STATE_EXTRACT_REPORTS = ['CBM0C1', 'CBM0CS'];
export const isTexasStateExtract = (code) => TEXAS_STATE_EXTRACT_REPORTS.includes(code);
/* These reports pick their census term in Step 2, and an extraction stays current only for that term. */
export const picksCensusTerm = (code) => isTexasStateExtract(code);

export const getReportMeta = (code) => CBM_REPORT_META[code] || { fullName: '', due: '', frequency: '', sources: [] };

/* The API serves bare years (e.g. 2026); the design displays academic-year ranges. */
export const formatAcademicYear = (year) => {
    const y = Number(year);
    return y ? `${y - 1}–${y}` : '';
};

/* Design palette (colors_and_type.css / Thesis UI Kit tokens used by the wizard screens) */
export const CBM_COLORS = {
    accent: '#079EC2',        // pacific blue — primary brand, text/outlined/links
    accentLight: '#3DB5D2',   // bright teal — CTA hover, outline border
    accentSoft: '#6AC5DA',    // bright-teal-soft — primary FILLED button background
    accentPress: '#CDECF3',   // pressed / disabled-primary background
    accentBgSel: '#E6F5F9',   // sky-10 tint — selected rows/chips/tabs
    accentBgInfo: '#E6FBFC',  // aqua-10 tint — info callout bg
    accentInk: '#01708A',     // dark pacific-blue ink — text on light-teal badges
    link: '#3C66C4',          // link blue — Student ID cells
    text: '#424B5C',          // river-bed — primary text
    textMuted: '#9FA0A2',     // star-dust — secondary text
    border: '#E3E7EA',        // soft card border
    borderInput: '#D1D1D1',   // table divider / field border
    success: '#379D00',       // success ink
    successBg: '#F0FBF0',
    successLight: '#65D568',  // success border
    warning: '#E89500',       // validation-warning border (amber, distinct from error)
    warningBg: '#FFF4E0',
    warningInk: '#9C5A00',    // validation-warning value/text
    danger: '#FB5801',        // error / mandatory asterisk
    dangerBg: '#FBEBE2',
    canvas: '#F8FAFB',        // page/table-header tint
    cardShadow: '0 0 6px rgba(211, 211, 211, 0.74)' // --shadow-card
};
